import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import CreditCardOutlinedSvg from "@ant-design/icons-svg/es/asn/CreditCardOutlined";
import AntdIcon from "../components/AntdIcon";
var CreditCardOutlined = function CreditCardOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: CreditCardOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  CreditCardOutlined.displayName = 'CreditCardOutlined';
}
export default /*#__PURE__*/React.forwardRef(CreditCardOutlined);